const useValidation = () => {

  const isNotEmpty = (str: string | null | undefined): boolean => {
    return !!str?.trim();
  }

  const isPhoneNumber = (phone: string): boolean => {
    return phone.length == 10 && phone.replace(/[^0-9]/g, '') == phone;
  }

  const isEmail = (address: string | null): boolean => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test((String(address) || '').toLowerCase());
  }

  return { isNotEmpty, isPhoneNumber, isEmail };

}

export default useValidation;